export default __webpack_public_path__ + "static/Logo_no_tagline-388f25a4b99938e58308e24a2d5ba1c7.png";